import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OdataObject } from '@common/models';
import { ODataServiceFactory } from '@common/odata';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StoragesService {
  private http = inject(HttpClient);
  private odataFactory = inject(ODataServiceFactory);

  checkDefaultObjectLock(): Observable<number | null> {
    return this.http
      .get<OdataObject<number | null>>(this.odataFactory.CreateService('/Storages/GetDefaultImmutabilityPeriod').Query().GetUrl())
      .pipe(map((res) => res?.value));
  }
}
